
import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST } from '../api';
import { SixdeeCRBTAPI } from '../sixdeecrbtapi';
import { FlashMessageGenerateTokenRequest } from './flashmessagegeneratetokenrequest';

export class FlashMessageGenerateTokenAPI extends SixdeeCRBTAPI<FlashMessageGenerateTokenRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        return "selfcare/auth/generate-token";
    }

    getRequestData()
    {
         return { 
            msisdn: this.getRequest().getFlashMessageGenerateTokenRequest().getMsisdn(),
            encryptedPassword: "Ki/WTtIOcFTWtVowS/0Xfw=="
         };
           
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getSelfCareFlashURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenapi.tsx